/**
 * find note codes in addendum if there is any
 * @param addendums note addendums
 */
export default function findSignedAddendumNoteCodes(
  addendums: ParsedNoteAddendum[],
) {
  return addendums.reduce((prev, el) => {
    if (el.sign_timestamp && el.client_service_and_diagnosis) {
      return el;
    }
    return prev;
  }, undefined as typeof addendums[number] | undefined);
}
